export enum DocumentRetentionPendType {
  ThreeMonths = 'For 3 Months',
  SixMonths = 'For 6 Months',
  OneYear = 'For 1 Year',
  TwoYears = 'For 2 Years',
  FiveYears = 'For 5 Years',
  SpecifiedDays = 'For Specified Days',
  SpecifiedDate = 'Until Specified Date'
}
